function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "home"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.665 10.253-9-8c-.379-.338-.95-.338-1.329 0l-9 8c-.413.366-.45.999-.083 1.411.367.413.998.452 1.412.083l.335-.298v7.551c0 1.654 1.346 3 3 3h3c.552 0 1-.447 1-1v-6h2v6c0 .553.448 1 1 1h3c1.654 0 3-1.346 3-3v-7.551l.335.298c.191.17.428.253.665.253.276 0 .55-.113.748-.336.366-.412.329-1.045-.083-1.411zm-3.665 8.747c0 .552-.449 1-1 1h-2v-5c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v5h-2c-.551 0-1-.448-1-1v-9.329l6-5.333 6 5.333z"
}));

var Svg051Home = function Svg051Home(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg051Home, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/051-home.c6d282ee.svg";
export { ForwardRef as ReactComponent };